import React, { Fragment, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';

import ClubAvatar from 'app/components/club/ClubAvatar';
import FeedContainer from 'app/components/feed/FeedContainer';
import MembershipStatus from 'app/components/membership/MembershipStatus';
import Page from 'app/components/pages/Page';

import useApp from 'app/context/useApp';

import { container } from 'app/styles/new-layout';

const useStyles = makeStyles(theme => ({
    container: {
        ...container(theme),
        display: 'flex',
        padding: theme.spacing(3),
        alignItems: 'flex-start',
    },
    content: {
        flexGrow: 1,
        position: 'relative',
        paddingRight: theme.spacing(3),

        [theme.breakpoints.down('md')]: {
            paddingRight: '0px',
        }
    },
    nav: {
        position: 'relative',
        flexGrow: 0,
        flexBasis: '320px',
        flexShrink: 0,

        [theme.breakpoints.down('md')]: {
            display: 'none',
        }
    },

    paperMembership: {
        padding: theme.spacing(3)
    },
    membershipContainer: {
        marginTop: theme.spacing(3)
    },
    backgroundImage: {
        marginTop: '-78px'
    }
}));

export default function Feed(props) {

    const { app } = useApp();

    const classes = useStyles();

    const pageId = useMemo(() => app.club.pages.find(page => page.path === 'dashboard').id, []);

    return (
        <Fragment>
            <Page id={pageId} height="auto" noSkeleton/>
            <div className={classes.container}>
                <div className={classes.content}>
                    <FeedContainer app={app}/>
                </div>
                <div className={classes.nav}>
                    <Paper className={classes.paperMembership}>
                        <ClubAvatar club={app.club} />
                        <div className={classes.membershipContainer}>
                            <MembershipStatus app={app}/>
                        </div>
                    </Paper>
                </div>
            </div>
        </Fragment>
    )
}
